import axios from 'axios';

const ip_dev_url = "https://175.207.29.152:39001/api/v1/";
const host_dev_url = "https://tapi.thehae.biz/api/v1/"

function baseInstance(url) {

  const instance = axios.create({
    baseURL:`/api/v1/${url}/`
    ,
    headers: {
      userKey: sessionStorage.getItem('userKey')
    },
  })
  return instance
}

function loginInstance(url) {
  const instance = axios.create({
    baseURL: `/api/v1/${url}/`
    ,
    headers: {
    
    },
  })

  return instance
}

export var login = loginInstance('login');
export var common = loginInstance('common');
export var user = baseInstance('user')
export var fus = baseInstance('fus')
export var banners = baseInstance('banner')
export var boards = baseInstance('board')
export var mining = baseInstance('mining')
export var notice = baseInstance('notice')
export var info = baseInstance('info')
export var contact = baseInstance('contact')
export var event = baseInstance('event')
export var daily = baseInstance('daily')
export var game = baseInstance('game')
export var nft = baseInstance("nft")
export var ngame = baseInstance("ngame")

function reInitInstance(){
  login = loginInstance('login');
  common = loginInstance('common');
  user = baseInstance('user')
  fus = baseInstance('fus')
  banners = baseInstance('banner')
  boards = baseInstance('board')
  mining = baseInstance('mining')
  notice = baseInstance('notice')
  info = baseInstance('info')
  contact = baseInstance('contact')
  event = baseInstance('event')
  daily = baseInstance('daily')
  game = baseInstance('game')
  nft = baseInstance("nft")
  ngame = baseInstance("ngame")
}
export { reInitInstance }